// @flow

import React, { useEffect, useState } from "react";
import GraphiQL, { ToolbarSelect, ToolbarSelectOption } from "graphiql";
import GraphiQLExplorer from "graphiql-explorer";
import {
  buildClientSchema,
  getIntrospectionQuery,
  print,
  parse,
} from "graphql";
import { makeDefaultArg, getDefaultScalarArgValue } from "./CustomArgs";
import { Hypnosis } from "react-cssfx-loading";

import "graphiql/graphiql.css";
import "./App.css";

import { GraphQLSchema } from "graphql";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Button,
  Fade,
  Toast,
  ToastHeader,
  ToastBody,
  Row,
  Col,
} from "reactstrap";
import { X, CheckSquare, Plus, Trash } from "react-feather";

function fetcher(params: Object): Object {
  let path = document.location.pathname;
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    path = "http://localhost:7003/graphiql";
  }
  return fetch(path, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  })
    .then(function(response) {
      return response.text();
    })
    .then(function(responseBody) {
      try {
        console.log(JSON.parse(responseBody));
        return JSON.parse(responseBody);
      } catch (e) {
        console.log(e);
        return e;
      }
    });
}

function fetcherSchema(): Object {
  let path = "/schema/active";
  return fetch(path)
    .then(function(response) {
      return response.text();
    })
    .then(function(responseBody) {
      try {
        return JSON.parse(responseBody);
      } catch (e) {
        return responseBody;
      }
    });
}

const DEFAULT_QUERY = `# shift-option/alt-click on a query below to jump to it in the explorer`;

type State = {
  schema: ?GraphQLSchema,
  query: string,
  explorerIsOpen: boolean,
  graphteon: Object,
};

const Filter = ({
  fields,
  filter,
  onFilterRemove,
  position,
  onFilterChange,
}) => {
  function onChange(e) {
    filter[e.target.name] = e.target.value;
    onFilterChange(position, filter);
  }

  return (
    <Row className="w-100">
      <Col>
        <FormGroup>
          <Input type="select" name="field" onChange={onChange}>
            {fields.map((field) => (
              <option
                value={field}
                selected={filter.field === field ? "true" : null}
              >
                {field}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Col>
      <Col>
        <FormGroup>
          <Input type="select" name="operator" onChange={onChange}>
            <option
              value="eq"
              selected={filter.operator === "eq" ? true : null}
            >
              =
            </option>
            <option
              value="lt"
              selected={filter.operator === "lt" ? true : null}
            >
              &lt;
            </option>
            <option
              value="lte"
              selected={filter.operator === "lte" ? true : null}
            >
              &lt;=
            </option>
            <option
              value="gt"
              selected={filter.operator === "gt" ? true : null}
            >
              &gt;
            </option>
            <option
              value="gte"
              selected={filter.operator === "gte" ? true : null}
            >
              &gt;=
            </option>
            <option
              value="like"
              selected={filter.operator === "like" ? true : null}
            >
              LIKE
            </option>
            <option
              value="not"
              selected={filter.operator === "not" ? true : null}
            >
              NOT
            </option>
            <option
              value="isEmpty"
              selected={filter.operator === "isEmpty" ? true : null}
            >
              IS EMPTY
            </option>
            <option
              value="notEmpty"
              selected={filter.operator === "notEmpty" ? true : null}
            >
              IS NOT EMPTY
            </option>
          </Input>
        </FormGroup>
      </Col>
      <Col>
        <FormGroup>
          <Input
            type="text"
            name="value"
            value={filter.value}
            onChange={onChange}
            placeholder="value"
          />
        </FormGroup>
      </Col>
      <Col md="1">
        <FormGroup>
          <Button
            outline
            color="secondary"
            className="mr-1"
            onClick={() => onFilterRemove(position)}
          >
            <Trash size={16} />
          </Button>
        </FormGroup>
      </Col>
    </Row>
  );
};

const FilterRow = ({ fields = [], onApply, onOperatorChange }) => {
  const [filters, setFilters] = useState([
    { operator: "like", value: "", field: fields[0] },
  ]);

  function onRemove(position) {
    if (filters.length === 1) return;
    filters.splice(position, 1);
    setFilters([...filters]);
  }

  function onChange(position, filter) {
    filters[position] = filter;
    setFilters([...filters]);
  }

  useEffect(() => {
    onApply(filters);
  }, [filters]);

  console.log(fields);

  return (
    <Row>
      <Col>
        <Form onSubmit={(e) => e.preventDefault()}>
          <div className="form-body">
            <Row className="w-100">
              <Col md="3">
                <FormGroup>
                  <label>Select Operator</label>
                  <Input
                    type="select"
                    name="searchOperator"
                    onChange={(e) => onOperatorChange(e.target.value)}
                  >
                    <option value="AND">AND</option>
                    <option value="OR">OR</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            {filters.map((filter, idx) => (
              <Filter
                fields={fields}
                filter={filter}
                onFilterRemove={onRemove}
                onFilterChange={onChange}
                key={idx}
                position={idx}
              />
            ))}
            <Row>
              <Col md="1">
                <Button
                  outline
                  color="secondary"
                  className="mr-1"
                  onClick={() =>
                    setFilters([
                      ...filters,
                      { operator: "like", value: "", field: fields[0] },
                    ])
                  }
                >
                  <Plus size={16} />
                </Button>
              </Col>
            </Row>
          </div>
          <div className="form-actions">
            <Button
              outline
              color="warning"
              className="mr-1 mt-3"
              onClick={() => {
                setFilters([{ operator: "like", value: "", field: fields[0] }]);
                onApply(filters);
              }}
            >
              <X size={16} /> Reset
            </Button>
            {/* <Button outline color="primary" onClick={() => { onApply(filters); }}>
              <CheckSquare size={16} /> Apply Filter
            </Button> */}
          </div>
        </Form>
      </Col>
    </Row>
  );
};

const App = ({ schema, query, explorerIsOpen }: State) => {
  const [data, setData] = useState({
    schema: null,
    query: DEFAULT_QUERY,
    explorerIsOpen: false,
    graphteon: null,
  });
  const [gqlVariables, setGqlVariables] = useState("");
  const [selectTypeMenu, setSelectTypeMenu] = useState("");
  const [gqlOperation, setGqlOperation] = useState("");
  const [gqlFilterOperator, setGqlFilterOperator] = useState("AND");
  const [gqlFilters, setGqlFilters] = useState([]);
  const [isFetcherDone, setIsFetcherDone] = useState(false);
  const [isgraphteonExist, setIsgraphteonExist] = useState(false);
  const [GraphiQlInit, setGraphiQlInit] = useState(null);
  const [isExplorerOpen, setIsExplorerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchableFields, setSearchableFields] = useState();
  const [showAlert, setShowAlert] = useState(false);
  let count = 0
  // const [selectedEntity, setSelectedEntity] = useState(false)

  function getTableHead() {
    return Object.keys(data.graphteon[selectTypeMenu].body.storedProps).filter(
      (item) => item !== "id"
    );
  }

  function getSearchableFields() {
    const fields = data.graphteon[selectTypeMenu].body.storedProps;
    return Object.keys(fields).filter((key) => {
      const val = fields[key];
      return val.meta.searchable && key !== "id";
    });
  }
  function generateQuery() {
    let selectedQuery = "";
    let variables = "{}";
    if (selectTypeMenu.length === 0 && gqlOperation.length === 0) {
      query = data.query;
    } else {
      const fieldArr = getTableHead();

      if (gqlOperation === "query") {
        selectedQuery = prettify(
          `query get${selectTypeMenu}List {
            get${selectTypeMenu}List {
              ${fieldArr.join("\n")}
            }
          }`
        );
      } else if (gqlOperation === "pageList") {
        selectedQuery = prettify(
          `query get${selectTypeMenu}Page($page: Int, $pageSize: Int) {
            get${selectTypeMenu}Page(page: $page, pageSize: $pageSize) {
              items {
                ${fieldArr.join("\n")}
              }
              total
              page
              offset
              totalPage
              prevPage
              nextPage
            }
          }`
        );
        variables = `{\n\t"page": 1,\n\t"pageSize": 25\n}`;
      } else if (gqlOperation === "create") {
        selectedQuery = prettify(`
          mutation insert${selectTypeMenu}($input:${selectTypeMenu}Input) {
            insert${selectTypeMenu}(input :$input) {
              ${fieldArr.join("\n")}
            }
          }`);
        let params = {};
        fieldArr
          .filter((item) => item !== "createdAt" && item !== "updatedAt")
          .forEach((f) => (params[f] = ""));
        variables = prettify(`
        {
          "input": ${JSON.stringify(params)}
        }`);
      } else if (gqlOperation === "update") {
        selectedQuery = prettify(`
          mutation edit${selectTypeMenu}($input:${selectTypeMenu}Input) {
            edit${selectTypeMenu}(input :$input) {
              ${fieldArr.join("\n")}
            }
          }`);
        let params = {};
        params["id"] = "idToUpdate";
        fieldArr
          .filter((item) => item !== "createdAt" && item !== "updatedAt")
          .forEach((f) => (params[f] = ""));
        variables = prettify(`
        {
          "input": ${JSON.stringify(params)}
        }`);
      } else if (gqlOperation === "delete") {
        selectedQuery = prettify(`
          mutation delete${selectTypeMenu}($id:ID) {
            delete${selectTypeMenu}(id :$id)
          }`);
        variables = prettify(`
        {
          "id": "idToDelete"
        }`);
      } else if (gqlOperation === "bulkCreate") {
        selectedQuery = prettify(`
          mutation insertMultiple${selectTypeMenu}($input:[${selectTypeMenu}Input]) {
            insertMultiple${selectTypeMenu}(input :$input) {
              ${fieldArr.join("\n")}
            }
          }`);
        let params = {};
        fieldArr
          .filter((item) => item !== "createdAt" && item !== "updatedAt")
          .forEach((f) => (params[f] = ""));
        variables = `
          {
            "input": [${JSON.stringify(params)},${JSON.stringify(params)}]
          }`;
      } else if (gqlOperation === "bulkUpdate") {
        selectedQuery = prettify(`
        mutation editMultiple${selectTypeMenu}($input:[${selectTypeMenu}Input]) {
          editMultiple${selectTypeMenu}(input :$input) {
            ${fieldArr.join("\n")}
          }
        }`);
        let params = {};
        params["id"] = "idToUpdate";
        fieldArr
          .filter((item) => item !== "createdAt" && item !== "updatedAt")
          .forEach((f) => (params[f] = ""));
        variables = `
        {
          "input": [${JSON.stringify(params)},${JSON.stringify(params)}]
        }`;
      } else if (gqlOperation === "bulkDelete") {
        selectedQuery = prettify(`
          mutation deleteMultiple${selectTypeMenu}($ids:[ID]) {
            deleteMultiple${selectTypeMenu}(ids :$ids)
          }`);
        variables = `
          {
            "ids": ["idToDelete1", "idToDelete2"]
          }`;
      } else if (gqlOperation === "filtering") {
        selectedQuery = prettify(
          `query get${selectTypeMenu}FilteredList($input: ${selectTypeMenu}SearchInput) {
            get${selectTypeMenu}FilteredList(${
            gqlFilterOperator === "AND" ? "search" : "searchAny"
          }:$input) {
              ${getSearchableFields().join("\n")}
            }
          }`
        );
        let filters = {};
        gqlFilters.forEach((f) => {
          if (filters[f.field] === undefined) filters[f.field] = [];
          filters[f.field].push({ operator: f.operator, value: f.value });
        });
        variables = `
          {
            "input": ${JSON.stringify(filters)}
          }`;
      }
    }
    setGqlVariables(variables);
    setData((prevState) => ({ ...prevState, query: selectedQuery }));
  }

  function prettify(str) {
    try {
      return print(parse(str));
    } catch (err) {
      return str;
    }
  }

  function _handleInspectOperation(
    cm: any,
    mousePos: { line: Number, ch: Number }
  ) {
    const parsedQuery = parse(query || "");

    if (!parsedQuery) {
      console.error("Couldn't parse query document");
      return null;
    }

    var token = cm.getTokenAt(mousePos);
    var start = { line: mousePos.line, ch: token.start };
    var end = { line: mousePos.line, ch: token.end };
    var relevantMousePos = {
      start: cm.indexFromPos(start),
      end: cm.indexFromPos(end),
    };

    var position = relevantMousePos;

    var def = parsedQuery.definitions.find((definition) => {
      if (!definition.loc) {
        console.log("Missing location information for definition");
        return false;
      }

      const { start, end } = definition.loc;
      return start <= position.start && end >= position.end;
    });

    if (!def) {
      console.error(
        "Unable to find definition corresponding to mouse position"
      );
      return null;
    }

    var operationKind =
      def.kind === "OperationDefinition"
        ? def.operation
        : def.kind === "FragmentDefinition"
        ? "fragment"
        : "unknown";

    var operationName =
      def.kind === "OperationDefinition" && !!def.name
        ? def.name.value
        : def.kind === "FragmentDefinition" && !!def.name
        ? def.name.value
        : "unknown";

    var selector = `.graphiql-explorer-root #${operationKind}-${operationName}`;

    var el = document.querySelector(selector);
    el && el.scrollIntoView();
  }

  function _handleEditQuery(query: string) {
    setData((prevState) => ({ ...prevState, query: query }));
  }

  function _handleToggleExplorer() {
    // console.log("handleToggler clicked");

    setIsExplorerOpen(!isExplorerOpen);
  }

  useEffect(() => {
    fetcher({
      query: getIntrospectionQuery(),
    }).then((result) => {
      setData((prevState) => ({
        ...prevState,
        schema: buildClientSchema(result.data),
      }));
      setIsFetcherDone(true);
      // console.log(result.data);
    });
  }, []);

  useEffect(() => {
    if (isFetcherDone) {
      fetcherSchema().then((res) => {
        // console.log("fetcher Schema", res.schema.objects);

        setData((prevState) => ({
          ...prevState,
          graphteon: res.schema.objects,
        }));
      });
    }
  }, [isFetcherDone]);

  useEffect(() => {
    if (data && data.graphteon) {
      setIsgraphteonExist(true);
    }
  }, [data]);

  useEffect(() => {
    if (data && data.graphteon) {
      generateQuery();
      setSearchableFields(getSearchableFields());
    }
  }, [selectTypeMenu, gqlOperation]);


  useEffect(() => {
    let interval
    if (!showAlert) {
       interval = setInterval(()=>setShowAlert(false),3000)
    }
    else {
      clearInterval(interval)
    }
    
    //cleanup function
    return ()=> clearInterval(interval)
  },[])

  if (!isgraphteonExist) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Hypnosis />
      </div>
    );
  }

  return (
    <>
          <Modal
            // scrollable
            isOpen={isModalOpen}
            toggle={() => setIsModalOpen(!isModalOpen)}
          >
            <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>
              Filter By
            </ModalHeader>
            <ModalBody>
              <FilterRow
                fields={searchableFields}
                onApply={(filters) => setGqlFilters(filters)}
                onOperatorChange={(operator) => setGqlOperation(operator)}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                onClick={() => {
                  setGqlOperation("filtering");
                  setIsModalOpen(!isModalOpen);
                }}
              >
                Apply Filter
              </Button>
              <Button onClick={() => setIsModalOpen(!isModalOpen)}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>

      {showAlert && 
        <Toast
          className="mx-3 position-absolute top-0 end-0"
          style={{ zIndex: "100" }}
        >
          <ToastHeader icon="warning">Warning</ToastHeader>
          <ToastBody>Please select the entity!
          </ToastBody>
        </Toast>
        
      }

      <div className="graphiql-container z-index-n1">
        <GraphiQLExplorer
          schema={data.schema}
          query={data.query}
          onEdit={_handleEditQuery}
          onRunOperation={(operationName) =>
            GraphiQL.handleRunQuery(operationName)
          }
          explorerIsOpen={isExplorerOpen}
          onToggleExplorer={_handleToggleExplorer}
          getDefaultScalarArgValue={getDefaultScalarArgValue}
          makeDefaultArg={makeDefaultArg}
        />
        <GraphiQL
          ref={(ref) => setGraphiQlInit(ref)}
          fetcher={fetcher}
          schema={data.schema}
          query={data.query}
          variables={gqlVariables}
          onEditQuery={_handleEditQuery}
        >
          <GraphiQL.Toolbar>
            <GraphiQL.Button
              onClick={() => GraphiQlInit.handlePrettifyQuery()}
              label="Prettify"
              title="Prettify Query (Shift-Ctrl-P)"
            />
            <GraphiQL.Button
              onClick={() => GraphiQlInit.handleToggleHistory()}
              label="History"
              title="Show History"
            />
            <GraphiQL.Button
              onClick={_handleToggleExplorer}
              label="Explorer"
              title="Toggle Explorer"
            />
            <GraphiQL.Group>
              <ToolbarSelect>
                <ToolbarSelectOption
                  label={
                    selectTypeMenu.length === 0
                      ? "Select Entity"
                      : selectTypeMenu
                  }
                  title="Select Entity"
                  selected={true}
                />
                {data &&
                  data.graphteon &&
                  Object.keys(data.graphteon)
                    .sort()
                    .map((entity) => {
                      if (data.graphteon[entity].__type === "Entity") {
                        return (
                          <ToolbarSelectOption
                            key={entity}
                            label={entity}
                            title={entity}
                            onSelect={() => { setSelectTypeMenu(entity);gqlOperation==="filtering"?setGqlOperation(""):setGqlOperation(gqlOperation) }}
                          ></ToolbarSelectOption>
                        );
                      }
                      return "";
                    })}
              </ToolbarSelect>

              <GraphiQL.Button
                onClick={() => {selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("query") }}
                label="Query"
                title="Query Menu"
              />
              <GraphiQL.Button
                onClick={() => {
                  selectTypeMenu.length === 0 ? setShowAlert(true) :
                  // setGqlOperation("filtering");
                  setIsModalOpen(!isModalOpen);setGqlOperation("");
                }}
                label="Filter"
                title="Filter List Menu"
              />
              <GraphiQL.Button
                onClick={() => selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("pageList")}
                label="Page List"
                title="Page List Menu"
              />
              <GraphiQL.Menu
                label={
                  gqlOperation.length === 0 ||
                  gqlOperation === "query" ||
                  gqlOperation === "pageList" ||
                  gqlOperation === "filtering" ||
                  gqlOperation === "bulkCreate" ||
                  gqlOperation === "bulkUpdate" ||
                  gqlOperation === "bulkDelete"
                    ? "Mutation"
                    : gqlOperation
                }
                title="Select Mutation Menu"
              >
                <GraphiQL.MenuItem
                  onSelect={() => selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("create")}
                  label="Create"
                  title="Toggle Explorer"
                ></GraphiQL.MenuItem>
                <GraphiQL.MenuItem
                  onSelect={() => selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("update")}
                  label="Update"
                  title="Toggle Explorer"
                ></GraphiQL.MenuItem>
                <GraphiQL.MenuItem
                  onSelect={() => selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("delete")}
                  label="Delete"
                  title="Toggle Explorer"
                ></GraphiQL.MenuItem>
              </GraphiQL.Menu>
              <GraphiQL.Menu
                label="Bulk Mutation"
                title="Select Bulk Mutation Menu"
              >
                <GraphiQL.MenuItem
                  onSelect={() => selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("bulkCreate")}
                  label="Bulk Create"
                  title="Toggle Explorer"
                ></GraphiQL.MenuItem>
                <GraphiQL.MenuItem
                  onSelect={() => selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("bulkUpdate")}
                  label="Bulk Update"
                  title="Toggle Explorer"
                ></GraphiQL.MenuItem>
                <GraphiQL.MenuItem
                  onSelect={() => selectTypeMenu.length===0 ?setShowAlert(true):setGqlOperation("bulkDelete")}
                  label="Bulk Delete"
                  title="Toggle Explorer"
                ></GraphiQL.MenuItem>
              </GraphiQL.Menu>
            </GraphiQL.Group>
          </GraphiQL.Toolbar>
        </GraphiQL>
      </div>
    </>
  );
};

export default App;
